<template>
    <div>
        <v-data-table
            disable-initial-sort
            :headers="invoiceHeaders"
            no-data-text="Nenhuma factura adicionada"
            :items="invoices"
            :loading="loading"
            hide-actions
        >
            <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.code ? getInvoiceCode(props.item) : 'Fatura programada' }}</td>
                
                <td class="text-xs-right">{{ props.item.emission_date | formatDate}}</td>
                <td class="text-xs-right" :style="[isInvoicePaymentLate(props.item) ? {'color': 'red'} : {'color':''}]" >{{ props.item.due_date | formatDate}}</td>
                <td class="text-xs-right">{{ props.item.pendent_value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                <td class="text-xs-right">{{ props.item.total_value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                <td class="justify-center layout px-0">
                    <v-icon v-ripple class="mr-2" small @click.stop="showItem(props.item)">open_in_new</v-icon>
                    <v-icon v-ripple v-if="!props.item.code && props.item.types_operation_type_id !== Types.operation_type.ANULADO" small class="mr-2" @click.stop="openEditDate(props.item, props.index)">calendar_today</v-icon>
                </td>
            </template>
        </v-data-table>

        <!--ScheduledInvoice-->
        <scheduled-invoice 
            @onScheduledInvoiceDone="refreshInvoiceList()"
        ></scheduled-invoice>

    </div>
</template>

<script>

import moment from 'moment';
// import InvoiceReceiptPaper from '../invoice/InvoiceReceipt';
import {Permissions, Tax, Types, Global} from "../../config";
import ScheduledInvoice from '../invoice/ScheduledInvoice';
import {eventBus} from "../../main";
export default {
    name: "ATShowInvoiceTable",
    data () {
        return {
            Global,
            Types,
            invoiceHeaders: [
                {text: 'Código Fatura', align: 'left', value: 'code'},
                {text: 'Emissão', align: 'right', value: 'emission_date'},
                {text: 'Vencimento', align: 'right', value: 'due_date'},
                {text: 'Pendente', align: 'right', value: 'pendent_value'},
                {text: 'Total', align: 'right', value: 'total_value'},
                {text: 'Ações', align: 'right', value: '', sortable: false}
            ],
        }
    },

    props:{
        invoices: Array,
        loading: Boolean,
    },

    components: {
        ScheduledInvoice,
        // InvoiceReceiptPaper
    },

    computed: {
        showInvoiceModal: {
            get(){
                return this.$store.getters.getShowInvoiceModal;
            },
            set(value){
                this.$store.dispatch('setShowInvoiceModal', value);
            }
        },
        showInvoiceReceiptModal: {
            get(){
                return this.$store.getters.getShowInvoiceReceiptPaperModal;
            },
            set(value){
                this.$store.dispatch('setShowInvoiceReceiptPaperModal', value);
            }
        },
        selectedInvoice: {
            get(){
                return this.$store.getters.getSelectedInvoice;
            },
            set(value){
                this.$store.dispatch('setSelectedInvoice', value);
            }
        },
        showScheduledInvoice: {
            get(){
                return this.$store.getters.getShowScheduledInvoice;
            },
            set(value){
                this.$store.dispatch('setShowScheduledInvoice', value)
            }
        },
    },

    methods: {
        
        getInvoiceCode(invoice){
            return invoice.code+'/'+invoice.series;
        },

        isInvoicePaymentLate($invoice){
            return moment().diff($invoice.due_date, 'days') > 0 && $invoice.pendent_value > 0;
        },

        refreshInvoiceList(){
            this.$emit('onScheduledInvoiceFinish');
        },

        showItem(item){

            this.selectedInvoice = item;
            this.consoleLog('selected invoice vvv');
            this.consoleLog(this.selectedInvoice);

            switch (this.selectedInvoice.types_document_id) {
                case Types.document_type.FACTURA_RECIBO:
                    this.showInvoiceReceiptPaper();
                    break;
                case Types.document_type.FACTURA:
                    this.showInvoicePaper();
                    break;
            }
        },

        
        openEditDate(item, index){
            // this.consoleLog('edit dates');
            this.showScheduledInvoice = true;
            this.selectedInvoice = item;
            eventBus.$emit('onScheculedInvoiceOpened');
        },
    
        showInvoicePaper(){
            this.consoleLog('opening InvoicePaper');
            this.showInvoiceModal = true;
        },

        showInvoiceReceiptPaper(){
            this.consoleLog('opening InvoiceReceiptPaper');
            this.showInvoiceReceiptModal = true;
        },
    }
}
</script>